export const productPrices = {
  productPrices: {
    crossedPrice: {
      label: 'Statt',
    },
  },
};
